/**
 * container/recruit.js
 */

import { connect } from 'react-redux';
import recruit from '../component/recruit/';
import { fetchData } from '../actions/recruit';

// componentのpropsで使えるようにする
const mapStateToProps = (state,ownProps) => ({
  ownProps:ownProps,
  recruit_data:state.recruit.result
});

// componentでdispatchを使えるようにする
const mapDispatchToProps = dispatch => ({
  getData: (value) => { 
    return dispatch(fetchData(value))
  }
});

export default connect(mapStateToProps,mapDispatchToProps)(recruit);


// WEBPACK FOOTER //
// ./src/container/recruit.js